import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    courseCard: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
        paddingLeft: 15,
        border: '1px solid',
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main
    },
    courseCardContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: "start",
        width: "100%",
        padding: 0,
        paddingLeft: 20
    },
    courseHeader: {
        color: theme.palette.text.primary,
        textAlign: "left",
        fontWeight: "bolder",
        fontSize: (props) => props.headerSize ? props.headerSize : 16
    },
    courseContent: {
        color: theme.palette.text.secondary,
        textAlign: "left",
        paddingTop: 2,
        fontSize: (props) => props.textSize ? props.textSize : 14
    },
    icon: {
        height: 25,
        width: 25
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "center",
        paddingRight: 5,
        color: theme.palette.text.secondary
    },
    trailingHeaderHow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
        justifyContent: "space-between",
        minWidth: 80
    }
}));

export {useStyles};
